import React, {useState} from 'react';


export const TrailAccount =(props)=>{
     
    return <div className="trail-expires" >
                <span>{props.traildays}</span>
                <span>Days remaining before your trial expires</span>
                <span><a href="#" onClick={props.close} >Subscribe Now</a></span>
                <span className="t-right" onClick={props.close} >Close</span>
            </div>
   
}
export default TrailAccount;